<template>
    <div class="registration-container col-12 mt-3">
        <div class=" pb-5">
            <div class="row ">
                <div class="col-12 ">
                    <b-form class="auth-form" @submit.prevent="Login" autocomplete="off">

                        <div class="row ">
                            <div class="col-12 mt-3 px-lg-3">
                                <input class="form-control" required v-model="payload.user_login"
                                       aria-label="user-login" placeholder="Логин *">
                            </div>
                            <div class="col-12 mt-3 px-lg-3">
                                <input class="form-control" required type="password" v-model="payload.user_password"
                                       aria-label="user-password" placeholder="Пароль *">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mt-3 px-lg-3">
                                <input class="form-control email-input" required v-model="payload.user_email"
                                       aria-label="user-email" placeholder="E-mail адрес *">
                            </div>
                            <div class="col-12 mt-3 px-lg-3">
                                <the-mask :mask="['+#(###)-###-##-##', '+#(###)-###-##-###']" class="form-control" v-model="payload.user_phone"
                                          required type="text" aria-label="user-phone" placeholder="Номер телефона *" ></the-mask>
                            </div>
                        </div>
                        <div class="row mt-3 mx-0">
                          <div class="col-12">
                            <label class="mr-3 text-white">У вас есть промокод?</label>
                            <input type="checkbox" v-model="payload.promo_exist" @change="unsetParams" aria-label="promo-exist">
                          </div>
                        </div>
                        <div class="row" v-if="payload.promo_exist">
                            <div class="col-12 mt-3 px-lg-3">
                                <input class="form-control" required v-model="payload.promo_code" aria-label="promo-code" placeholder="Промо-код">
                            </div>
                        </div>
                        <div class="row" v-else-if="!enabledRegistration"  id="users_referer_area">
                          <div class="col-12 mt-3 px-lg-3">
                            <input class="form-control" required v-model="payload.referer_login" aria-label="referer-login" placeholder="Логин друга *">
                          </div>
                          <div class="col-12 mt-3 px-lg-3">
                            <input class="form-control" required v-model="payload.contact_info" aria-label="contact-info" placeholder="Ваша контактная информация для связи *">
                          </div>
                        </div>
                        <div class="row mx-0">
                            <div class="col-12">
                                <alert :message="response"></alert>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="row mx-0" v-if="getAdminTgLinks">
                          <span class="text-white"> В случае возникновения вопросов, пожалуйста, обращайтесь в
                            <a target="_blank" :href="getAdminTgLinks">администрацию сайта через Telegram.</a></span>
                        </div>

                        <div class="row">
                            <div class="col-12 mt-3">
                                <button class="btn auth-button pink-btn w-100 border-0"
                                        @click.prevent="Registration" :disabled="isSubmitting">
                                    Зарегистрироваться
                                </button>
                            </div>
                        </div>

                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from '@/components/Alert'

    export default {
        name: 'Register',
        props:['activeTab'],
        components: {
            Alert
        },
        data() {
            return {
                response: null,
                isSubmitting: false,
                payload: {
                    user_login: '',
                    user_email: '',
                    user_password: '',
                    user_phone: '',
                    promo_code: '',
                    user_currency: 1,
                    referer_login: '',
                    contact_info: '',
                    promo_exist: true,
                }
            }
        },
        methods: {
          Registration() {
            this.response = {status: 'loading'}
            this.isSubmitting = true

            if (this.payload.user_login === '' || this.payload.user_email === '' || this.payload.user_password === '') {
              this.isSubmitting = false
              this.response = {status: 'error', msg: 'Заполните все необходимые поля'}
              return
            }
            let sendData  = this.payload
            if(!this.payload.promo_exist){
              delete sendData.promo_exist
            }
            this.axios.post(
              this.$_config.baseUrl + '/Api/registration',
              sendData, {
                withCredentials: true
              }
            ).then(({data}) => {
              this.isSubmitting = false
              this.response = data
              if (data.status === 'ok') {
                this.$store.dispatch('fetchUserData')
                this.$store.dispatch('getMainSettings')
                this.$store.dispatch('fetchApiData')
                setTimeout(() => {
                  if (!this.userData) {
                    window.location.reload()
                  }
                }, 5000)
              }
            }).catch((err) => {
              if (err) {
                this.isSubmitting = false
                this.response = {status: 'error', msg: err.response.data.errors}
              }
            })
          },
          unsetParams() {
            this.payload.promo_code = "";
            this.payload.referer_login = "";
            this.payload.contact_info = "";
          }
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['userData']
            },
            enabledRegistration(){
              return this.$store.getters.getEnabledRegistration
            },
            getAdminTgLinks() {
              return this.$store.getters.getSocialLinks['site_administration']
            }
        },
        watch: {
            isAuthorized(newValue) {
                if (newValue) {
                    this.$router.push({name: 'home'})
                }
            },
            activeTab(newVal){
                if(newVal){
                    this.response = null;
                }
            }
        },
        mounted() {
            if (this.isAuthorized) {
                this.$router.push({name: 'home'})
            }
        }
    }
</script>

<style scoped>
.form-control{
    background: #071637;
    border: 2px solid transparent;
    border-radius: 8px;
    color: #fff;
    height: 44px;
    outline: none !important;
    padding: 0 12px;
    touch-action: manipulation;
    width: 100%;
}

</style>
